title: Settings
tabs:
  agencyAndUsers:
    title: Agency & Users
  myProfile:
    title: My Profile
  billing:
    title: Billing & Subscriptions
  brokerUsers:
    title: Broker Users
  rysSummary:
    title: API Summary
    description: A summary of which yachts and fleets your API will show.
  rysFeaturedYachts:
    title: Featured Yachts
  rysExcludedYachts:
    title: Hidden Yachts
  enquiries:
    title: Enquiry Routing
  fleetAccess:
    title: Fleet Authorisation
  iframe:
    title: iFrame Configuration
  api:
    title: API Credentials
  fleetDistribution:
    title: Fleet Distribution
    description: Control how your fleet is distributed to charter brokers via the Charter Index API service.
groups:
  agency:
    title: Your Agency
  profile:
    title: Your Profile
  rysApi:
    title: Your Website API
  rysIframe:
    title: Your Website iFrame
  fleet:
    title: Your Fleet
